import { memo } from "react";
import { useSelector } from 'react-redux'
import { ConfigProvider } from 'antd';
import AuthApp from '@mods/userManagement/auth/routes';
import Layouts from "./Layout";
import { AppProvider } from "../utils/context";
import { IntlProvider } from "react-intl";
import AppLocale from '../lngProvider/index';
import { appTheme } from "./theme";
const App = () => {
  const authUser = useSelector((state) => state.auth.authUser);
  const currentAppLocale = AppLocale["en"]



  return (
    <AppProvider>
      <ConfigProvider theme={ appTheme }>
        <IntlProvider messages={ currentAppLocale.messages }
          locale={ currentAppLocale.locale } defaultLocale="en">
          { authUser ? <Layouts /> : <AuthApp /> }
        </IntlProvider>
      </ConfigProvider>
    </AppProvider>

  );
}

export default memo(App);
